import { useEffect, useState } from 'react';
import type { Meeting } from '@penticton-dev-events/shared';

import { useFirebaseServices } from '../../../app/providers/FirebaseProvider';
import { subscribeToMeetingsByGroup } from '../api/meetingRepository';

export type UseMeetingsState = {
  readonly meetings: Meeting[];
  readonly loading: boolean;
  readonly error: Error | null;
};

export const useMeetingsByGroup = (groupId: string | null): UseMeetingsState => {
  const { firestore } = useFirebaseServices();
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [loading, setLoading] = useState<boolean>(Boolean(groupId));
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!groupId) {
      setMeetings([]);
      setLoading(false);
      return () => undefined;
    }

    setLoading(true);
    setError(null);
    const unsubscribe = subscribeToMeetingsByGroup(
      firestore,
      groupId,
      nextMeetings => {
        setMeetings(nextMeetings);
        setLoading(false);
      },
      subscriptionError => {
        setError(subscriptionError);
        setLoading(false);
      },
    );

    return () => {
      unsubscribe();
    };
  }, [firestore, groupId]);

  return { meetings, loading, error };
};
